import { Layout } from "@certn/cascadia-react";
import { ReactNode } from "react";

import { AppFooterLinks } from "./app-footer/AppFooterLinks";

interface Props {
  children: ReactNode;
}

export function RegionEntitlementDeniedLayout(props: Props) {
  return (
    <Layout layout="narrow" footer={<AppFooterLinks />}>
      {props.children}
    </Layout>
  );
}
